






















































import SwitchByUa from '@/components/atoms/SwitchByUa.vue'
import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import { log } from '@/log'
import { ApiContent } from '@/models/api/content'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { allInactive, ApplicationState } from '@/models/application-state/application-state'
import { ApplicationStateGateway } from '@/models/application-state/application-state-gateway'
import { ApplicationStateGatewayWhichCallEachApi } from '@/models/application-state/gateway/application-state-gateway-which-call-each-api'
import * as CurrentTime from '@/models/current-time/functions'
import FreeAreaService from '@/services/free-area/free-area'
import { MypageFreeArea } from '@/services/free-area/mypage/mypage-free-area'
import { EventBusForThirdParty } from '@/usecases/event-bus-for-third-party/event-bus'
import HeaderBottomUserNotification from '@ajax/vue/components/templates/HeaderBottomUserNotification.vue'
import AboutMycolor from '@spa/components/organisms/mypage/top/AboutMyColor.vue'
import UserInfo from '@spa/components/organisms/mypage/user-info/UserInfo.vue'
import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'
import { User } from '@spa/store/modules/user/types'
import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'
import OnlyFreeAreaLayout from './layout/OnlyFreeAreaLayout.vue'
import PresetLayout from './layout/PresetLayout.vue'

@Component({
  components: {
    AboutMycolor,
    UserInfo,
    SpaErrorDialog,
    SwitchByUa,
    PresetLayout,
    OnlyFreeAreaLayout,
    /**
     * 本当はSPA内全ページに埋め込まれるように、Default.vueなどに実装したかったが、
     * 以下の理由で断念し、ピンポイントで必要な箇所に実装する方針とした。
     * @see https://github.com/Everforth/growthpalette-front/pull/8205#discussion_r1836048045
     *
     * ヘッダーの下に入りこまないように.l-containerがpadding-topを持っているので、
     * .l-containerの中にHeaderBottomUserNotificationを入れる必要があった。
     * （なおAjax時には.l-containerのpadding-topは上書きされ0pxとなっている）
     *
     * SPA/Ajax全体のヘッダーに対するコンテンツのpadding-topの考え方は整理したほうが良さそう
     * @see https://github.com/Everforth/growthpalette-front/issues/7997
     */
    HeaderBottomUserNotification,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class Top extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ default: () => FreeAreaService.createForHost(MypageFreeArea) })
  readonly freeAreaService: FreeAreaService

  @Prop({ default: () => ApplicationStateGatewayWhichCallEachApi.setupDefault() })
  readonly applicationStateGateway: ApplicationStateGateway

  headerFreeArea: ApiContent = ApiContent.empty

  Status = Status
  status: Status = Status.Pending
  showModal: boolean = false
  showExternalLoginModal: boolean = false
  modalMessage: string = ''
  behaviorConfig = new BehaviorConfig()

  applicationState: ApplicationState = allInactive

  get topUrl(): string {
    return this.$store.getters['history/topUrl'] || '/'
  }

  get hasExternalLoginError(): boolean {
    return _.get(this.$route.query, 'external-login-error') === 'true'
  }

  get user(): User {
    return this.$store.state.user.user
  }

  get errorOnLoad() {
    return _.get(this.$store.state.user, 'error.load')
  }

  get isLoading(): boolean {
    return this.status === Status.Loading
  }

  get carat(): string {
    return this.$store.getters['user/getCarat']
  }

  async mounted() {
    if (this.hasExternalLoginError) {
      this.showExternalLoginModal = true
    }

    this.status = Status.Loading

    this.$store.dispatch('history/setUrlToContinueShopping')
    await this.freeAreaService.fetch().then(([header]) => {
      this.headerFreeArea = header || ApiContent.empty
    })

    this.status = Status.Completed
  }

  async created() {

    this.status = Status.Loading

    await this.initOrElseRedirectUser()

    await this.initializeApplicationState()

    this.status = Status.Completed

    EventBusForThirdParty.getInstance().publish('page-initialized', {
      url: window.location.href,
      initializedAt: CurrentTime.create().now,
      user: this.user,
    })
  }

  async initOrElseRedirectUser(): Promise<void> {

    // Load User
    await this.$store.dispatch('user/get', { force: true })

    const user = this.$store.state.user.user

    if (!user) {
      this.modalMessage = 'ログインできませんでした。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
      this.showModal = true

      this.$router.push('/login')

      return
    }

    // other
    if (this.errorOnLoad) {
      this.modalMessage = 'お客様情報が取得できませんでした。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
      this.showModal = true

      this.status = Status.Failed

      return
    }
  }

  private initializeApplicationState(): Promise<void> {
    return this.applicationStateGateway.on('point-on-error', (e) => {
      log.error(e)

      this.modalMessage += 'ポイント情報が取得できませんでした<br>'
    }).on('subscription-on-error', (e) => {
      log.error(e)

      this.modalMessage += '定期購入の設定が取得できませんでした<br>'
    }).fetch().then(result => result.fold(
      () => {
        this.modalMessage += '※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
        this.showModal = true
      },
      (state) => {
        this.applicationState = state
      }
    ))
  }
}
